import {
  createReqConsts,
  createActions,
  createReqReducer,
} from '../../utils/redux';

export const consts = createReqConsts('health-board', 'appointment-filters', [
  'SET',
]);
export const actions = createActions(consts);
const requestReducer = createReqReducer(consts);

const initialState = {
  isFilterToday: true,
  isFilterByTypeVisit: false,
};

const clear = state => ({
  ...state,
  ...initialState,
});

export default (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case consts.CLEAR:
      return clear(state);

    case consts.SET:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return requestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/healthboard/appointment-upcoming-filters.js